export const ADMIN_SCROLLBAR_CLASSES =
  'scrollbar scrollbar-track-[#1A1A1A] scrollbar-thumb-[#303030] scrollbar-thumb-rounded-full scrollbar-track-rounded-full';

export const ACCESS_TYPE_COLORS: Record<string, string> = {
  VIEWER: '#60A5FA',
  EDITOR: '#FB923C',
  ADMIN: '#C3D82E',
};

// Sort/display order: ADMIN first, then EDITOR, then VIEWER
export const ACCESS_TYPE_SORT_ORDER: Record<string, number> = { ADMIN: 0, EDITOR: 1, VIEWER: 2 };
